import React from 'react';
import CompanyProfile from '../operations/CompanyProfile';
import ContactManager from '../operations/contacts/ContactManager';

interface OperationsWorkspaceProps {
  activeArea: string;
}

export default function OperationsWorkspace({ activeArea }: OperationsWorkspaceProps) {
  switch (activeArea) {
    case 'company':
      return <CompanyProfile />;
    case 'contacts':
      return <ContactManager />;
    case 'settings':
      return (
        <div className="space-y-4">
          <p className="text-gray-600">Configure your operations settings here.</p>
        </div>
      );
    case 'overview':
    default:
      return (
        <div className="space-y-4">
          <p className="text-gray-600">Welcome to Operations! Here's an overview of your business operations:</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="p-4 bg-blue-50 rounded-lg">
              <h3 className="font-medium text-gray-900 mb-2">Company Status</h3>
              <p className="text-gray-600">View and manage your company profile and settings</p>
            </div>
            <div className="p-4 bg-blue-50 rounded-lg">
              <h3 className="font-medium text-gray-900 mb-2">Business Operations</h3>
              <p className="text-gray-600">Monitor and optimize your business processes</p>
            </div>
          </div>
        </div>
      );
  }
}